/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_accounts_polygon_no_cards = /** @type {(inputs: {}) => string} */ () => {
	return `No tienes tarjetas disponibles. Crea una tarjeta primero.`
};

const en_accounts_polygon_no_cards = /** @type {(inputs: {}) => string} */ () => {
	return `You don't have any available cards. Create a card first.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const accounts_polygon_no_cards = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.accounts_polygon_no_cards(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("accounts_polygon_no_cards", locale)
	if (locale === "es") return es_accounts_polygon_no_cards(inputs)
	return en_accounts_polygon_no_cards(inputs)
};
export { accounts_polygon_no_cards as "accounts.polygon.no_cards" }